import useGraphicStandMutationDelete from './graphic-stand-use-mutation-delete';
import useGraphicStandMutationCreateUpdate from './graphic-stand-use-mutation-create-update';
import useGraphicStandMutationExportExcel from './graphic-stand-use-mutation-export-excel';

export const useGraphicStandMutation = {
    delete: useGraphicStandMutationDelete,
    createUpdate: useGraphicStandMutationCreateUpdate,
    exportExcel: useGraphicStandMutationExportExcel
};

export default useGraphicStandMutation;